// extracted by mini-css-extract-plugin
export default {"tableTitle":"TableHeader_tableTitle__PHOjV","headerCounters":"TableHeader_headerCounters__D2h3J"};